<template>
  <v-container>
    <v-row><h1>Configure AlcoMeasure Email Addresses</h1></v-row>
    <v-row><p class="error" v-if="error">{{ error }}</p></v-row>
    <v-row>
      <v-snackbar v-model="updated" timeout="6000">
        Saved
        <template v-slot:action="{ attrs }">
          <v-btn color="blue" text v-bind="attrs" @click="updated = false">
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </v-row>

    <v-container v-if="selectedBusinessId != ''">

      <v-row class="mb-4">
        <h2>Sites</h2>
        <v-spacer/>
        <!-- <v-btn icon @click="showAddSiteDialog"> -->
        <v-btn color="secondary" @click="showAddSiteDialog">
          <!-- <v-icon> mdi-plus </v-icon> -->
          Add Site
        </v-btn>
        <v-btn class="ml-2" color="primary" @click="saveChanges">
          Save Changes
        </v-btn>
      </v-row>

      <v-card
        v-for="(site, siteIndex) in sites"
        :key="site.name"
        outlined
        class="mb-2"
      >
        <v-card-title primary-title>
          {{ site.name }}
          <v-btn icon color="primary" @click="showEditSiteNameDialog(siteIndex)">
            <v-icon>
              mdi-pencil
            </v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn icon color="error" @click="showDeleteSiteDialog(siteIndex)">
            <v-icon>
              mdi-delete-alert
            </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-list dense>
            <v-list-item
              v-for="(address, index) in site.addresses"
              :key="index"
            >
              <v-row>
                <v-col sm="11">
                  <v-text-field v-model="site.addresses[index]" />
                </v-col>
                <v-col sm="1" class="pt-6">
                  <v-btn icon color="error" @click="deleteAddress(site, index)">
                    <v-icon>
                      mdi-delete
                    </v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-list-item>
          </v-list>
          <v-row justify="center">
            <v-btn icon @click="addAddress(site)">
              <v-icon> mdi-plus </v-icon>
            </v-btn>
          </v-row>
        </v-card-text>
      </v-card>
    </v-container>
    <confirm-dialog ref="confirm" />
    <text-entry-dialog ref="textentry" />
  </v-container>
</template>

<script>
import BusinessService from '../services/BusinessService';
import UserService from '../services/UserService';
import ConfirmDialog from '../components/dialogs/ConfirmDialog.vue';
import TextEntryDialog from '../components/dialogs/TextEntryDialog.vue';

export default {
  name: 'AlcoMeasure',
  components: {
    ConfirmDialog,
    TextEntryDialog,
  },
  data() {
    return {
      business: {},
      error: '',
      updated: false,
      dialog: false,
      selectedBusinessId: '',
      user: {},
      userId: this.$auth.user.sub.split('|')[1],
      fallbackEmail: '',
      sites: [
      ],
    };
  },
  async created() {
    const token = await this.$auth.getTokenSilently();
    this.user = await UserService.getUser(this.userId, token);
    const { businessIds } = this.user;
    if (businessIds.length > 0) {
      [this.selectedBusinessId] = businessIds;
      this.business = await BusinessService.getBusiness(
        this.selectedBusinessId,
        token,
      );
      if (
        this.business
        && this.business.notificationEmailAddresses
        && this.business.notificationEmailAddresses.alcomeasure
      ) {
        const alcomeasureEmails = this.business.notificationEmailAddresses.alcomeasure;
        this.fallbackEmail = alcomeasureEmails.fallback;
        this.sites = alcomeasureEmails.sites;
      } else {
        console.log('No existing AlcoMeasure settings on business');
      }
    }
  },
  computed: {},
  methods: {
    reportError(err) {
      this.error = err.message;
    },
    addAddress(site) {
      site.addresses.push('');
    },
    deleteAddress(site, index) {
      site.addresses.splice(index, 1);
    },
    async showAddSiteDialog() {
      const name = await this.$refs.textentry.open(
        'Enter site name',
      );
      if (name) {
        this.addSite(name);
      }
    },
    addSite(name) {
      this.sites.push({
        name,
        addresses: [''],
      });
    },
    async showDeleteSiteDialog(index) {
      if (
        await this.$refs.confirm.open(
          'Confirm',
          'Are you sure you want to delete this site?',
        )
      ) {
        this.deleteSite(index);
      }
    },
    deleteSite(index) {
      // TODO: Add confirmation
      this.sites.splice(index, 1);
    },
    async showEditSiteNameDialog(index) {
      const name = await this.$refs.textentry.open(
        'Enter site name',
      );
      if (name) {
        this.editSiteName(index, name);
      }
    },
    editSiteName(index, name) {
      this.sites[index].name = name;
    },
    async saveChanges() {
      // TODO: Save sites to business
      const token = await this.$auth.getTokenSilently();
      BusinessService.saveAlcomeasureSiteEmails(
        this.selectedBusinessId,
        token,
        { sites: this.sites },
      )
        .then(() => {
          this.updated = true;
          this.error = '';
        })
        .catch(() => {
          this.error = 'Couldn\'t save changes';
        });
    },
  },
};
</script>

<style scoped>
div.container {
  /* max-width: 800px; */
  padding: 10px;
  margin: 0 auto;
}

p.error {
  border: 1px solid #ff5b5f;
  background-color: #ffc5c1;
  padding: 10px;
  margin-bottom: 15px;
}
</style>
